import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Api from "../../../features/one-query/services/ApiServices";
import {
  VideoHistoryData,
  VideoModalData,
} from "../../../Types/VideoSuite-Types";
import { GetOptionsRequest } from "./SuiteHistroyApi";

// Get VideoSuiteHistory
const getVideosSuiteHistory = async (filterData?: GetOptionsRequest) => {
  try {
    const params = {
      StartDate: filterData?.StartDate,
      EndDate: filterData?.EndDate,
      AppIds: filterData?.AppIds?.join(","),
      Search: filterData?.Search,
    };
    const response = await Api.get("/VideoSuiteHistory", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useGetVideoSuiteHistory = (filterData?: GetOptionsRequest) => {
  return useQuery({
    queryKey: ["GetVideoSuiteHistory", filterData],
    queryFn: () => getVideosSuiteHistory(filterData),
    refetchOnWindowFocus: false,
  });
};

// ==========================================

// Get VideoSuiteHistory by ID

const getVideoSuiteHistoryDataById = async (id: string) => {
  try {
    const response = await Api.get(`/VideoSuiteHistory/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useGetVideoSuiteHistoryById = (id: string) => {
  return useQuery<VideoModalData>({
    queryKey: ["GetVideoSuiteHistoryById", id],
    queryFn: () => getVideoSuiteHistoryDataById(id),
    enabled: !!id,
  });
};

// ===========================================

// Get VideoSuiteHistory Apps
const getVideoSuiteHistoryApps = async () => {
  try {
    const response = await Api.get("/VideoSuiteHistory/Apps");
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useGetVideoSuiteHistoryApps = () => {
  return useQuery({
    queryKey: ["GetVideoSuiteHistoryApps"],
    queryFn: getVideoSuiteHistoryApps,
    enabled: false,
  });
};

// ===========================================

// delete VideoSuiteHistory
const deleteVideoSuiteHistory = async () => {
  try {
    const response = await Api.delete(`/VideoSuiteHistory`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useDeleteVideoSuiteHistory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["DeleteVideoSuiteHistory"],
    mutationFn: deleteVideoSuiteHistory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetVideoSuiteHistory"] });
    },
  });
};

// ===========================================

// delete VideoSuiteHistory by ID
const deleteVideoSuiteHistoryById = async (id: string) => {
  try {
    const response = await Api.delete(`/VideoSuiteHistory/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useDeleteVideoSuiteHistoryById = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["DeleteVideoSuiteHistoryById"],
    mutationFn: deleteVideoSuiteHistoryById,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetVideoSuiteHistory"] });
    },
  });
};

// ============================================

export {
  useGetVideoSuiteHistory,
  useGetVideoSuiteHistoryById,
  useGetVideoSuiteHistoryApps,
  useDeleteVideoSuiteHistory,
  useDeleteVideoSuiteHistoryById,
};
